import React, { useState } from "react";

const inputStyle = {
  width: "100%",
  padding: "10px",
  border: "1px solid #ddd",
  marginTop: 4,
  borderBottom: "2px solid rgb(58, 58, 58)",
  borderRadius: "4px 4px 0px 0px"
};

/**
 * FreeTextTags — mots-clés en saisie libre, affichés en tags.
 *
 * À la différence de CustomAutoComplete (qui sélectionne des fiches
 * existantes via Algolia), ce composant n'interroge aucune base : le texte
 * tapé est ajouté tel quel, qu'il corresponde ou non à une fiche existante.
 * Sert pour "À interroger" (AINTERROGER_ATR.ATR_NOM côté backend) : des
 * mots-clés libres associés à une fiche pour la faire remonter dans la
 * recherche, sans lien vers une autre fiche.
 *
 * Props :
 *   - name           : name de l'input
 *   - placeholder    : placeholder de l'input
 *   - selectedIds    : tableau d'ids de tags (géré par le parent)
 *   - selectedLabels : { id: texte } — le mot-clé affiché pour chaque tag
 *   - onChange       : callback(nextIds, nextLabels) à chaque ajout/retrait
 */
export default function FreeTextTags({
  name = "freeTextTags",
  placeholder = "Saisir un mot-clé puis Entrée",
  selectedIds = [],
  selectedLabels = {},
  onChange,
}) {
  const [value, setValue] = useState("");

  const addTag = () => {
    const texte = value.trim();
    if (!texte) return;
    const dejaPresent = Object.values(selectedLabels).some(
      (label) => (label || "").trim().toLowerCase() === texte.toLowerCase()
    );
    setValue("");
    if (dejaPresent) return;

    const id = `tmp_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
    onChange([...selectedIds, id], { ...selectedLabels, [id]: texte });
  };

  const removeTag = (id) => {
    const nextLabels = { ...selectedLabels };
    delete nextLabels[id];
    onChange(selectedIds.filter((sid) => sid !== id), nextLabels);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div>
      <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
        <input
          type="text"
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          style={{ ...inputStyle, flex: 1 }}
          autoComplete="off"
        />
        <button
          type="button"
          onClick={addTag}
          className="fr-btn--secondary"
          style={{ marginTop: 4, whiteSpace: "nowrap",padding:10 }}
        >
          Ajouter
        </button>
      </div>

      {selectedIds.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
          {selectedIds.map((id) => (
            <span
              key={id}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                background: "#dbeafe",
                color: "#1e40af",
                border: "1px solid #93c5fd",
                borderRadius: 20,
                padding: "3px 10px",
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              {selectedLabels[id] || id}
              <button
                type="button"
                onClick={() => removeTag(id)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#1e40af",
                  fontWeight: "bold",
                  fontSize: 14,
                  lineHeight: 1,
                  padding: 0,
                }}
                title={`Retirer ${selectedLabels[id] || id}`}
              >
                ✕
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
